module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("欢迎使用")]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("CloudLinker 账号登录")]), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules,
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "domain"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "团队ID"
    },
    on: {
      "blur": _vm.checkCaptcha
    },
    model: {
      value: (_vm.loginForm.domain),
      callback: function($$v) {
        _vm.loginForm.domain = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "loginForm.domain"
    }
  })], 1), _vm._v(" "), (!_vm.ssoOption.is_open_sso || (_vm.ssoOption.is_open_sso && _vm.ssoOption.is_account_password)) ? _c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "placeholder": "账号/邮箱"
    },
    on: {
      "blur": _vm.checkCaptcha
    },
    model: {
      value: (_vm.loginForm.username),
      callback: function($$v) {
        _vm.loginForm.username = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "loginForm.username"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.ssoOption.is_open_sso || (_vm.ssoOption.is_open_sso && _vm.ssoOption.is_account_password)) ? _c('el-form-item', {
    staticClass: "list-group-item",
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onKeyup()
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.loginForm.password = $$v
      },
      expression: "loginForm.password"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showCaptcha) ? _c('el-form-item', {
    attrs: {
      "prop": "captcha"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    staticClass: "form-control",
    attrs: {
      "required": "required",
      "placeholder": "验证码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onKeyup()
      }
    },
    model: {
      value: (_vm.loginForm.captcha),
      callback: function($$v) {
        _vm.loginForm.captcha = $$v
      },
      expression: "loginForm.captcha"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "send-code",
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "32px",
      "margin-top": "2px"
    },
    attrs: {
      "src": _vm.captchaSrc,
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "agree"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.loginForm.agree),
      callback: function($$v) {
        _vm.loginForm.agree = $$v
      },
      expression: "loginForm.agree"
    }
  }), _vm._v("\n\t\t\t\t\t我已阅读并同意\n\t\t\t\t\t"), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "/console.html#/user-agreement",
      "target": "_blank"
    }
  }, [_vm._v("用户协议")]), _vm._v("、\n\t\t\t\t\t"), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "/console.html#/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("隐私政策")])], 1), _vm._v(" "), (!_vm.ssoOption.is_open_sso || (_vm.ssoOption.is_open_sso && _vm.ssoOption.is_account_password)) ? _c('el-form-item', [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary",
      "disabled": _vm.loginForm.domain != '' && _vm.loginForm.username != '' && _vm.loginForm.password != '' && _vm.loginForm.agree ? false : true
    },
    on: {
      "click": function($event) {
        _vm.login(_vm.loginForm)
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("登录")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('span', [_c('span', [_vm._v("登录中")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.ssoOption.is_open_sso) ? _c('el-form-item', [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "disabled": !_vm.loginForm.agree
    },
    on: {
      "click": function($event) {
        _vm.ssoLogin()
      }
    }
  }, [_c('span', [_vm._v("使用SSO登录")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "capitalize clearfix"
  }, [_c('div', {
    staticClass: "but"
  }, [_c('router-link', {
    staticClass: "pull-right login-link",
    attrs: {
      "to": "forgetpsw"
    }
  }, [_vm._v("忘记密码?")]), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right login-link",
    attrs: {
      "to": "register"
    }
  }, [_vm._v("立即注册")])], 1)])], 1)], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo4.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright clearfix small"
  }, [_c('div', [_vm._v("Copyright 上海驻云信息科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\tPowered by\n\t\t\t"), _c('a', {
    staticClass: "text-primary new-block",
    attrs: {
      "href": "https://www.cloudcare.cn",
      "target": "_blank"
    }
  }, [_vm._v("cloudcare.cn")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7802c282"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 591
// module chunks = 4 5 6